import { FC } from 'react';
import EmptyStateAlerts from '../../components/Global/EmptyStateAlerts';
import { useLocationStore } from '../../stores/locationStore';

interface Props {
  featureFlag?: boolean;
}

const PageNotFound: FC<Props> = ({ featureFlag }) => {
  const { activeLocation } = useLocationStore();

  return (
    <div className='container'>
      <EmptyStateAlerts
        filterState={'page_not_found'}
        page='global'
        analytics={{
          name: 'invalid page',
          locationNum: activeLocation,
          path: window.location.href,
          featureFlagged:
            featureFlag === undefined ? 'N/A' : String(featureFlag),
        }}
      />
    </div>
  );
};

export default PageNotFound;
